import React from 'react'
import Aboutsec from '../Menabout/Aboutsec'
import Bredcrumb from '../Bredcrumb/Main'
import Img from '../../assets/images/background/banner-image-1.webp'

function Main() {
  return (
    <>
      <Bredcrumb subtitle="About Us" Img={Img} />
      <Aboutsec />
    </>
  )
}
export default Main
